import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const LightThemeIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      {...props}
    >
      <path
        d="M13.0004 2.73726V1.97705M13.0004 24.0231V23.2629M23.2632 13.0001H24.0234M1.97736 13.0001H2.73757M20.258 5.74327L20.7955 5.20572M5.20522 20.7945L5.74277 20.257M20.258 20.2569L20.7955 20.7945M5.20522 5.20566L5.74277 5.74321M19.0672 12.9585C19.0672 16.3173 16.3444 19.0402 12.9856 19.0402C9.62673 19.0402 6.90387 16.3173 6.90387 12.9585C6.90387 9.5997 9.62673 6.87684 12.9856 6.87684C16.3444 6.87684 19.0672 9.5997 19.0672 12.9585Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

LightThemeIcon.displayName = 'LightThemeIcon';
